<template>
  <v-container class="none-fluid">
    <banner>Research Domains</banner>
    <ul class="custom-tab">
      <li
        v-for="(domain, i) in domains"
        v-on:click="setActive(i)"
        :key="domain.id"
        :class="{ active: isActive(i) }"
      >
        {{ domain.title }}
      </li>
    </ul>
    <v-divider></v-divider>
    <div class="domain-container" v-if="domains[activeIdx]">
      <p v-html="$sanitize(domains[activeIdx].content)"></p>
      <v-expansion-panels v-model="panel" multiple>
        <v-expansion-panel
          v-if="domains[activeIdx].projects.length"
          key="project"
          expand
        >
          <v-expansion-panel-header class="expansion-header">
            Current Projects
          </v-expansion-panel-header>
          <v-expansion-panel-content class="expansion-content">
            <v-row>
              <v-col
                v-for="project in domains[activeIdx].projects"
                :key="project.id"
                cols="12"
                sm="6"
                md="4"
              >
                <v-hover v-slot="{ hover }">
                  <v-card class="mx-auto" :href="'/project?id=' + project.id">
                    <v-img
                      contain
                      class="white--text align-end"
                      height="300px"
                      :src="
                        project.thumbnail ||
                        'https://firebasestorage.googleapis.com/v0/b/uscinteractionlab.appspot.com/o/projects%2Fproject_placeholder.png?alt=media&token=76d05851-6808-4854-a317-1b0c81da9506'
                      "
                    >
                      <v-expand-transition>
                        <div
                          v-if="hover"
                          class="d-flex transition-fast-in-fast-out v-card--reveal caption"
                          style="height: 100%"
                        >
                          {{ project.summary }}
                        </div>
                      </v-expand-transition>
                    </v-img>

                    <v-card-text class="project-text">
                      {{ project.title }}
                    </v-card-text>
                  </v-card>
                </v-hover>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel
          v-if="domains[activeIdx].pastProjects.length"
          key="past project"
          expand
        >
          <v-expansion-panel-header class="expansion-header">
            Past Projects
          </v-expansion-panel-header>
          <v-expansion-panel-content class="expansion-content">
            <div
              v-for="project in domains[activeIdx].pastProjects"
              :key="project.id"
              class="expansion-subsection"
            >
              <a
                class="link"
                :href="
                  project.externalLink
                    ? project.externalLink
                    : '/project?id=' + project.id
                "
              >
                {{ project.title }}
              </a>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
  </v-container>
</template>

<script>
import { getAllDomains } from "../../service/research/domains";
import { getProjectLists } from "../../service/research/projects";
import Banner from "../global/Banner";

export default {
  components: {
    Banner,
  },
  data() {
    return {
      activeIdx: 0,
      domains: [],
      panel: [0],
    };
  },
  mounted() {
    getAllDomains()
      .then(async (data) => {
        this.domains = await Promise.all(
          data.map(async (domain) => {
            const { projects, pastProjects } = await getProjectLists(
              "domains",
              domain.id
            );
            return { ...domain, projects, pastProjects };
          })
        );
      })
      .catch((err) => {
        console.error(err.message);
      });
  },
  methods: {
    isActive: function (idx) {
      return idx === this.activeIdx;
    },
    setActive: function (idx) {
      this.activeIdx = idx;
    },
  },
};
</script>

<style lang="scss">
.custom-tab {
  margin-bottom: 30px;
}

.custom-tab li {
  color: rgba(153, 27, 30, 0.6);
  font-weight: 600;
  font-size: 1.2rem;
  cursor: pointer;
}

.custom-tab li:hover,
.active {
  color: rgba(153, 27, 30, 1) !important;
}

.domain-container > p,
h2 {
  margin: 15px 0px;
}
</style>
